import React from 'react';
import { Button, Link, Text } from '@ntuctech/tangram-web';
import styled from 'styled-components';

const NotverifiedDisplayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UpdateNowButton = styled(Button)`
  width: 20.5rem;
  animation: tilt-shaking 0.8s linear 2;

  @keyframes tilt-shaking {
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(3deg);
    }
    50% {
      transform: rotate(0eg);
    }
    75% {
      transform: rotate(-3deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }

  @media (max-width: 768px) {
    width: 17.5rem;
  }
`;

const FaqWrapper = styled.div`
  margin-top: 1.5rem;
`;

const TncLink = styled(Link)`
  color: #0e44c0;
`;

const BrandLogo = styled.img`
  margin: auto;
  max-height: 2rem;
`;

const PromoBanner = styled.div`
  background: #fff5f8;
  width: 20.5rem;
  border-radius: 0.5rem;
  display: flex;
  padding: 0.75rem 1rem;
  margin: 1.5rem;

  @media (max-width: 768px) {
    width: 17.5rem;
  }
`;

export const MyinfoNotVerifiedDisplay = ({ promoBanner }) => {
  return (
    <NotverifiedDisplayWrapper>
      <Text>{promoBanner.description}</Text>
      <div style={{ ...(!promoBanner?.promoBanner && { marginTop: '1.5rem' }) }}>
        {promoBanner?.promoBanner && (
          <PromoBanner>
            <div>
              <div>
                <Text size="m" bold>
                  {promoBanner?.promoBanner?.description}
                </Text>
              </div>
              <div>
                <Link size="s" href={promoBanner?.promoBanner?.tnc?.url}>
                  {promoBanner?.promoBanner?.tnc?.text}
                </Link>
              </div>
            </div>
            <BrandLogo src={promoBanner?.promoBanner?.logo} />
          </PromoBanner>
        )}
      </div>
      <UpdateNowButton variant="primary" onClick={promoBanner?.handleOnClick}>
        {promoBanner?.ctaText}
      </UpdateNowButton>
      <FaqWrapper>
        <Text>
          Need help? Visit our <TncLink href={promoBanner?.faqUrl}>FAQ</TncLink>.
        </Text>
      </FaqWrapper>
    </NotverifiedDisplayWrapper>
  );
};

export const MyinfoFullVerifiedDisplay = ({ faqUrl }) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Text>
        To learn more, visit our <Link href={faqUrl}>FAQ</Link>.
      </Text>
    </div>
  );
};

export const TooltipHelper = ({ tooltipList = [] }) => {
  return (
    <div style={{ marginTop: '0.5rem' }}>
      <Text style={{ color: '#FFF' }}>Details retrieved from MyInfo:</Text>
      <ul style={{ margin: '0 auto', color: '#FFF' }}>
        {tooltipList.map((field) => {
          return <li key={field}>{field}</li>;
        })}
      </ul>
    </div>
  );
};
